import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          background: '#fff',
          border: '2px solid #dc3545',
          borderRadius: '8px',
          margin: '20px',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          <h1 style={{color: '#dc3545', marginTop: 0}}>⚠️ Something went wrong</h1>
          <h2 style={{fontSize: '18px', marginBottom: '16px'}}>Error Details:</h2>
          <div style={{
            background: '#f8f9fa',
            padding: '16px',
            borderRadius: '4px',
            fontFamily: 'monospace',
            fontSize: '14px',
            overflow: 'auto',
            maxHeight: '300px',
            marginBottom: '16px'
          }}>
            <strong>Error:</strong> {this.state.error && this.state.error.toString()}
            <br/><br/>
            <strong>Component Stack:</strong>
            <pre style={{margin: '8px 0 0 0', whiteSpace: 'pre-wrap'}}>
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#007bff',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '4px',
              fontSize: '16px',
              cursor: 'pointer',
              marginRight: '12px'
            }}
          >
            Reload Application
          </button>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null });
            }}
            style={{
              background: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '4px',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Try to Recover
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
